export const tailwindConfig = {
    fontFamily: {
      sans: ['Rubik', 'sans-serif'],
      montserrat: ['Montserrat', 'sans-serif'],
    },
    extend: {
      colors: {
        hpclBlue: {
            50: '#eaf0fa',
            100: '#d5e1f5',
            200: '#abc3ec',
            300: '#6d96dd',
            400: '#2f69cf',
            500: '#1e4384',
            600: '#193a72',
            700: '#143160',
            800: '#0f274e',
            900: '#0b1f3f',
            950: '#071733',
          },
        leftArrow: '#1e4384',
      },
      fontSize: {
        '2xs': ['0.625rem', '0.75rem'],
      },
      height: {
        26: '6.5rem',
      },
      width: {
        26: '6.5rem'
      },
      minHeight: {
        18: '4.5rem',
      },
      borderWidth: {
        '1.5': '1.5px',
      },
    }
  };